import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

export default (workspaceId: number | undefined) =>
  useQuery(['dataset-imports', workspaceId], () => peApi.getRecentImports(), {
    enabled: workspaceId !== null,
    refetchInterval: 5000,
  });
